import { bathymetricLegend } from '../config/legends'

const service =  {
    name: 'Bathymetry',
    label: 'Bathymetry',
    permissionId: 'bathymetry',
    iconComponent: 'Pipeline',
  showCoordinates: true,
  hideDatetimeSlider: true,
  disableMainDate: true,
  data: [
  ],
  layers: [
    {
      name: 'BathymetryWavelet',
      label: 'Bathymetry Wavelet',
      open: true,
      opacity: 'raster-opacity',
      datetimeId: 'BathymetryWavelet',
      secondary: false,
      legend: {
        type: 'categorical',
        data: bathymetricLegend
      },
    },
    {
      name: 'BathymetryFft',
      label: 'Bathymetry FFT',
      open: true,
      opacity: 'raster-opacity',
      datetimeId: 'BathymetryFft',
      secondary: false,
      legend: {
        type: 'categorical',
        data: bathymetricLegend
      },
    }
    ],
  locations: [
    {
      name: 'Senegal',
      latitude: 13.95,
      longitude: -17.57,
      zoom: [9]
    },
    {
      name: 'Perth',
      latitude: -32.05,
      longitude: 115.19,
      zoom: [9]
    },
    ]
}

export default service



// WEBPACK FOOTER //
// ./src/services/Bathymetry.js